export default {
	"dashboard": {
		"all": "所有",
		"own": "自己",
		"noConfirm": "待确认",
		"noPlan": "待计划",
		"distribution": "配送",
		"distributionPlan": "配送计划",
		"noDispatch": "待调度",
		"execute": "执行",
		"pending": "待处理",
		"tempMonitor": "温度监控",
		"monitoringRate": "监控率",
		"tempUpToStandard": "达标",
		"upToStandardRate": "达标率",
		"timeUpToStandard": "时效达标",
		"today": "今日",
		"yesterday": "昨日",
		"clickMarkRead": "点击标记已读",
		"doubleClickToTeadMore": "双击阅读具体内容",
		"noWarningMessage": "暂无预警消息",
		"noRemindMessage": "暂无提醒消息",
		"noNoticeMessage": "暂无通知消息",
		"gotIt": "知道了",
		"clickDownload": "点击下载",
		"quotation": "统采报价",
		"trunkLinePlan": "干线计划",
		"transportPlan": "运输计划",
		"refreshInSeconds": "秒后刷新",
		"shippingOrder": "运输订单",
		"plan": "计划",
		"schedule": "调度",
		"abnormal": "异常",
		"receipt": "回单",
		"notPickedUp": "未提货",
		"undelivered": "未送达",
		"driver": "司机"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/dashboard/dashboard.js